/**
 * @param {string} url
 */
const getIdFromEmbedUrl = url => {
  const typeformUrlRegexp =
    /^https:\/\/[a-zA-Z0-9]+\.typeform\.com\/to\/[a-zA-Z0-9]+$/i;
  if (!typeformUrlRegexp.test(url)) {
    throw new Error(
      'Typeform URL is not valid, should be like: "https://<WORKSPACE_ID>.typeform.com/to/<FORM_ID>"',
    );
  }

  return url.split('/').pop() || '';
};

export default getIdFromEmbedUrl;
